import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        root: css`
            ${custom.dashBoardRoot};
            height: 100%;
        `,
        main: css`
            ${common.fullContainer};
            display: flex;
            flex-grow: 1;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
        `,
    }
}

export default styles
